var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorizonScanningDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16175_105551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5V40.5H40V0.5H0ZM38.3833 38.8833H2.65278L7.83611 33.7C9.38856 34.956 11.3636 35.5688 13.3544 35.4121C15.3451 35.2553 17.2 34.341 18.5367 32.8575C19.8735 31.374 20.5904 29.4343 20.5397 27.438C20.4889 25.4417 19.6745 23.541 18.2641 22.1272C16.8538 20.7135 14.9549 19.8946 12.9588 19.8391C10.9626 19.7837 9.02121 20.4959 7.53454 21.8292C6.04787 23.1624 5.12917 25.0151 4.96771 27.0055C4.80624 28.9958 5.41432 30.9724 6.66667 32.5278L1.61944 37.5583V2.11667H38.3833V38.8833ZM6.56944 27.6083C6.5689 26.3957 6.92798 25.2102 7.60128 24.2016C8.27458 23.1931 9.23185 22.4069 10.352 21.9425C11.4722 21.478 12.7049 21.3562 13.8943 21.5925C15.0837 21.8287 16.1763 22.4124 17.034 23.2696C17.8916 24.1269 18.4758 25.2192 18.7126 26.4085C18.9493 27.5978 18.8281 28.8306 18.3642 29.951C17.9002 31.0714 17.1145 32.029 16.1062 32.7027C15.098 33.3765 13.9126 33.7361 12.7 33.7361C11.075 33.7346 9.51695 33.0887 8.36765 31.9399C7.21834 30.7911 6.57165 29.2333 6.56944 27.6083Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6446 12.9139L10.3696 8.97228L8.09184 5.02783L5.81684 8.97228L3.53906 12.9139H12.6446ZM7.25851 9.80561L8.09184 8.36116L8.92517 9.80561L9.75851 11.2473H6.42517L7.25851 9.80561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6002 17.511L22.3224 13.5694L20.0474 9.62769L17.778 13.5694L15.4946 17.511H24.6002ZM19.2141 14.4027L20.0474 12.961L20.8807 14.4027L21.7141 15.8444H18.3807L19.2141 14.4027Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6335 12.9139L33.3585 8.97228L31.0808 5.02783L28.8058 8.97228L26.5308 12.9139H35.6335ZM30.2502 9.80561L31.0835 8.36116L31.9169 9.80561L32.7502 11.2473H29.4169L30.2502 9.80561Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9444 36.3639H31.4944L29.2194 32.4194L26.9444 28.4778L24.6666 32.4194L22.3916 36.3639H26.9444ZM26.111 33.2528L26.9444 31.8111L27.7777 33.2528L28.611 34.6972H25.2777L26.111 33.2528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1749 24.8667L32.8971 20.9251L30.6221 16.9834L28.3332 20.9251L26.0693 24.8667H35.1749ZM29.7888 21.7584L30.6221 20.3167L31.4554 21.7584L32.2888 23.2001H28.9554L29.7888 21.7584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0945 24.1777H9.19727V31.075H16.0945V24.1777Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16175_105551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizonScanningDashboard);
export default __webpack_public_path__ + "static/media/horizon-scanning-dashboard.c8ffe0d5f7dbe39a524529e349147188.svg";
export { ForwardRef as ReactComponent };